var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXSymbolWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X-symbol",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18L18 0",
    transform: "translate(0.5208153 0.5208153)",
    id: "Line-5-Copy-2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18L18 0",
    transform: "matrix(-1 0 0 1 18.52081 0.5208153)",
    id: "Line-5-Copy-2",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSymbolWhite);
export default __webpack_public_path__ + "static/media/X-symbol-white.df75c742f09b8179457613fac886479e.svg";
export { ForwardRef as ReactComponent };